module.exports = __webpack_public_path__ + "menu-cancel.svg?02380bf18550e9d3691287438bfad780";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu-cancel.svg
// module id = 23
// module chunks = 0